import { Component, Input, Output, OnChanges, SimpleChanges, SimpleChange, EventEmitter } from '@angular/core';
import { Observable, Subject } from 'rxjs/Rx';
import { NetFacadeService } from '../../../services/netfacade.service';
import { AgentDto } from 'UvExplorerServer.Dtos.TS/Agents';
import { NetViewDto } from 'UvExplorerServer.Dtos.TS/NetViews';
import { ScheduledDiscovery } from 'DiscoveryEngine.TS/Discovery';
import { MessageService } from 'base';


@Component({
    selector: 'new-discovery-dialog',
	templateUrl: './newdiscovery.component.html',
    styleUrls: ['./newdiscovery.component.scss']
})
export class NewDiscoveryDialogComponent {

    @Input() display: boolean = false;
    @Input() parent: AgentDto;
	@Output() onSuccess = new EventEmitter();
	@Output() onClose = new EventEmitter();

	newItemName: string = "";

	constructor(private netFacadeService: NetFacadeService,
				private messageService: MessageService) {
    }

	public ngOnChanges(changes: SimpleChanges): void {
		let change: SimpleChange = null;

		change = changes["display"];
		if (change) {
			if (this.display) {
				this.newItemName = "";
			}
		}
	}

	public onDialogHide(): void {
		this.onClose.emit(true);
	}

	public addNewDiscovery(): void {
		this.netFacadeService.createScheduledDiscovery(this.newItemName, this.parent).subscribe(
			(newDisc: ScheduledDiscovery) => {
				this.onSuccess.emit(true);
			},
			(error: any) => {
				this.messageService.displayErrorMessage("Discovery creation failed");
			});
    }

    public displayDialog() {
        this.display = true;
    }

    public hideDialog() {
        this.display = false;
    }
}
